export const ENVIRONMENT_COLORS = {
  DANGER: '#FF7373',
  WARNING: '#FFDE69'
} as const

export const DANGER_ENVIRONMENTS = [
  'production-candidate',
  'pr-vs-prod-'
] as const
